import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

const Warning = createSvgIcon(
  <path d="M13.125 19.125a1.125 1.125 0 1 1-2.25 0 1.125 1.125 0 0 1 2.25 0Zm0-2.625v-6h-2.25v6h2.25Z M12 0 0 24h24L12 0Zm0 5.031 8.36 16.719H3.64L12 5.031Z" />,
  'Warning'
);

export { Warning };